import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import FacilityForm from '../Form';
import { createFacility } from '@resources/Facility/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createFacility, visible, onCancel } = props;
	const intl = useIntl();
	const handleSubmit = (data) => {
		return createFacility(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.facility.create',
						defaultMessage:
							'A new Facility has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.facility',
					defaultMessage: 'Create Facility',
				})}
			</Title>
			<FacilityForm onSubmit={handleSubmit} {...props} />
		</Modal>
	);
};

const mapStateToProps = ({ organization }) => {
	return {
		organization,
	};
};

export default connect(mapStateToProps, { createFacility })(Create);
